import { MS_PER_PIXEL, worldToScreenX } from "../timeline/book/BookLayout";
import type { TimelineVertex } from "./vertex-primitives";
import { pushWorldLine, type WorldView } from "./world-to-canvas";

/** World-space half-thickness of the white rail (full height = 2×). */
const RAIL_HALF_WIDTH_WORLD = 9;
/** World-space half-height of marks drawn inside the rail band. */
const RAIL_INNER_HALF_PX = 7;
/** Ruler minor tick spacing in world px (time-synced via scroll). */
const RULER_MINOR_STEP_PX = 12;
const RULER_MID_EVERY = 4;
const RULER_MAJOR_EVERY = 20;
const VIEW_MARGIN_PX = 192;

export function appendTimelineRail(
  verts: TimelineVertex[],
  scrollPx: number,
  axisY: number,
  worldWidth: number,
  view: WorldView,
  drawSpine = true,
): void {
  if (drawSpine) {
    pushWorldLine(
      verts,
      Math.max(0, -scrollPx),
      axisY,
      worldWidth,
      axisY,
      view,
      0.88,
      0.9,
      0.94,
      0.98,
      RAIL_HALF_WIDTH_WORLD,
    );
  }

  appendRulerMarks(verts, scrollPx, axisY, worldWidth, view);
}

function appendRulerMarks(
  verts: TimelineVertex[],
  scrollPx: number,
  axisY: number,
  worldWidth: number,
  view: WorldView,
): void {
  const viewLeft = view.originX - VIEW_MARGIN_PX;
  const viewRight = view.originX + view.canvasW / view.zoom + VIEW_MARGIN_PX;
  const cellMs = RULER_MINOR_STEP_PX * MS_PER_PIXEL;
  const worldStartMs = (scrollPx + viewLeft) * MS_PER_PIXEL;
  const worldEndMs = (scrollPx + viewRight) * MS_PER_PIXEL;
  const firstIndex = Math.floor(worldStartMs / cellMs);
  const lastIndex = Math.ceil(worldEndMs / cellMs);
  for (let index = firstIndex; index <= lastIndex; index++) {
    if (index < 0) {
      continue;
    }
    const x = worldToScreenX(index * cellMs, scrollPx);
    if (x < -RULER_MINOR_STEP_PX || x > worldWidth + RULER_MINOR_STEP_PX) {
      continue;
    }
    const major = index % RULER_MAJOR_EVERY === 0;
    const mid = !major && index % RULER_MID_EVERY === 0;
    const halfLen = major ? RAIL_INNER_HALF_PX - 1 : mid ? 4.5 : 2.5;
    const y1 = axisY - halfLen;
    const y2 = axisY + halfLen;
    const tickAlpha = major ? 0.85 : mid ? 0.7 : 0.5;
    pushWorldLine(
      verts,
      x,
      y1,
      x,
      y2,
      view,
      0.52,
      0.55,
      0.6,
      tickAlpha,
      major ? 2 : 1.5,
    );
  }
}
